import baseApi from './baseApi';
import {
    CarteMembreGetImageQuery,
    CarteMembreGetImageResponse,
    CarteMembreGetLienAndroidQuery,
    CarteMembreGetLienAndroidResponse,
} from './Schemas/CarteMembre';


const carteMembreApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getLienAndroid: builder.query<CarteMembreGetLienAndroidResponse, CarteMembreGetLienAndroidQuery>({
            query: ({idUnique}) => `carteMembre/lienAndroid/${idUnique}`,
        }),
        getCarteImage: builder.query<CarteMembreGetImageResponse, CarteMembreGetImageQuery>({
            query: ({idUnique}) => `carteMembre/carteimage/${idUnique}`,
        }),
        notifierTelechargementImage: builder.mutation<void, { idUniqueAdhesion: string }>({
            query: ({idUniqueAdhesion}) => ({
                url: `carteMembre/notifierTelechargementImage/${idUniqueAdhesion}`,
                method: 'POST',
            }),
        }),
        notifierTelechargementWallet: builder.mutation<void, { idUniqueAdhesion: string; type: 'ios' | 'android' }>({
            query: ({idUniqueAdhesion, type}) => ({
                url: `carteMembre/notifierTelechargementWallet/${idUniqueAdhesion}/${type}`,
                method: 'POST',
            }),
        }),
        envoyerLienCarteMembreParCourriel: builder.mutation<void, { idUniqueEmploye: string;}>({
            query: (body) => ({
                url: `carteMembre/envoyerParCourriel`,
                body,
                method: 'POST',
            }),

        }),
    }),
});

export const {
    useLazyGetLienAndroidQuery,
    useGetCarteImageQuery,
    useNotifierTelechargementImageMutation,
    useNotifierTelechargementWalletMutation,
    useEnvoyerLienCarteMembreParCourrielMutation,
} = carteMembreApi;

export default carteMembreApi;
